// extracted by mini-css-extract-plugin
module.exports = {"list":"FoodsCategories_list__1hJAw"};